import { render, staticRenderFns } from "./PricingButton.vue?vue&type=template&id=4ca5238d&scoped=true"
import script from "./PricingButton.vue?vue&type=script&lang=js"
export * from "./PricingButton.vue?vue&type=script&lang=js"
import style0 from "./PricingButton.vue?vue&type=style&index=0&id=4ca5238d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5238d",
  null
  
)

export default component.exports